import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import appReducer from './appSlice';
import uploadReducer from './uploadSlice';
export default configureStore({
  reducer: {
    auth: authReducer,
    app: appReducer,
    upload: uploadReducer,
  },
});
